module.exports = __webpack_public_path__ + "static/media/btn_benefit_cate_sp_on.d18cf84f.png";